import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import SyncDetails from "./routes/SyncDetails";

export default store => ({
  path: "logs",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "./components"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "Sync/modules/SyncModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const module2 = importedModule1;
        const reducer = module2.default;
        const key = module2.NAME;
        injectReducer(store, {
          key,
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [SyncDetails(store)],
});
